import React from "react";
import { Link } from "react-router-dom";
import {
    Collapse,
    List,
    ListItem,
    ListItemButton,
    ListItemIcon,
    ListItemText,
} from "@mui/material";

import ThisTheme from "../../../themes/LRSTheme";

import TimelineIcon from "@mui/icons-material/Timeline";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const LRSMenu = () => {
    const [open, setOpen] = React.useState(false);
    const handleClick = () => {
        setOpen(!open);
    };

    const menuItems = [
        {
            path: "/lrs",
            label: "Activities",
            icon: (
                <TimelineIcon sx={{ color: ThisTheme.palette.primary.main }} />
            ),
        },
    ];

    return (
        <List component="nav" className="menu-list" aria-label="LRS menu">
            <ListItem
                component="div"
                onClick={handleClick}
                aria-expanded={open}
                disablePadding
            >
                <ListItemButton>
                    <ListItemIcon>
                        <TimelineIcon
                            sx={{ color: ThisTheme.palette.primary.main }}
                        />
                    </ListItemIcon>
                    <ListItemText primary="LRS" />
                    {open ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                </ListItemButton>
            </ListItem>
            <Collapse in={open} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                    {menuItems &&
                        menuItems.length &&
                        menuItems.map(({ path, icon, label }) => (
                            <ListItem
                                key={path}
                                component={Link}
                                to={path}
                                disablePadding
                            >
                                <ListItemButton className="nested">
                                    <ListItemIcon>{icon}</ListItemIcon>
                                    <ListItemText>{label}</ListItemText>
                                </ListItemButton>
                            </ListItem>
                        ))}
                </List>
            </Collapse>
        </List>
    );
};

export default LRSMenu;
